import { ChannelLabel } from '../../types';

export enum QualityType {
  SQI = 'SQI',
  IMPEDANCE = 'IMPEDANCE',
}

export enum QualityColor {
  GOOD = '#209AF1',
  NOT_BAD = '#FBB80C',
  BAD = '#663DDB',
  ERROR = '#EB4D60',
  NO_SIGNAL = '#FFF',
}

export type QualityColorKey = keyof typeof QualityColor;

export interface LegendInfo {
  title: string;
  labels: Record<QualityColorKey, string>;
  toColor: (value: number | undefined) => QualityColor;
}

export interface SignalPointInfo {
  label: ChannelLabel;
  leftRatio?: number;
  rightRatio?: number;
  topRatio?: number;
  bottomRatio?: number;
}
